import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {SimpleFormikForm} from '../../../components/SimpleFormikForm/SimpleFormikForm';
import {FieldType} from '../../../components/SimpleFormikForm/types';
import {validateEmail} from '../../../utils/validators';

interface FormValues {
  email: string;
}

interface Props {
  onSubmit: (email: string) => void;
}
export const ForgotPassword = ({onSubmit}: Props) => {
  const {t} = useTranslation();
  const handleSubmit = (values: FormValues) => {
    onSubmit(values.email);
  };

  const validate = (values: FormValues) => {
    const errors: {[key: string]: string} = {};
    if (values.email && !validateEmail(values.email)) {
      errors.email = t('registration.signUp.formLabels.errorMessages.invalidEmail');
    }

    return errors;
  };

  const initialValues = {email: ''};

  const fields: FieldType<keyof FormValues>[] = [
    {
      componentType: 'text-field',
      type: 'text',
      fieldName: 'email',
      id: 'email',
      fieldLabel: t('registration.signUp.formLabels.email') || 'Email',
      testId: 'email-pw-reset-field',
    },
  ];

  return (
    <Grid sx={{maxWidth: '544px'}}>
      <Grid display='flex' justifyContent='center'>
        <Typography variant='h1' paddingBottom='16px'>
          {t('forgotPassword.title')}
        </Typography>
      </Grid>
      <SimpleFormikForm
        initialValues={initialValues}
        buttonText={t('passwordReset.button')}
        validate={validate}
        fields={fields}
        onSubmit={handleSubmit}
      />
    </Grid>
  );
};
